module.exports = __webpack_public_path__ + "img/adv1.4f2c6cef.jpg";